import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Mail, Send } from 'lucide-react';

export const Contact = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-700 to-blue-900">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.contact.title}
          </h1>
          <p className="text-xl text-blue-100">{t.contact.subtitle}</p>
        </div>

        <div
          data-testid="contact-email-card"
          className="bg-white/10 backdrop-blur border border-white/20 rounded-2xl shadow-xl p-6 sm:p-10 md:p-14 text-center text-white"
        >
          <div className="w-20 h-20 bg-white/10 backdrop-blur rounded-full flex items-center justify-center mx-auto mb-6">
            <Mail className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            {language === 'tr' ? 'Bize E-posta ile Ulaşın' : 'Reach Us via Email'}
          </h2>
          <p className="text-blue-100 text-base md:text-lg mb-8 mx-auto">
            <span className="block">
              {language === 'tr'
                ? 'Projeleriniz, teklif talepleriniz ve tüm sorularınız için bize aşağıdaki e-posta adresinden ulaşabilirsiniz.'
                : 'For your projects, quote requests and all inquiries, you can reach us at the email address below.'}
            </span>
            <span className="block">
              {language === 'tr'
                ? 'En kısa sürede size dönüş yapacağız.'
                : 'We will get back to you as soon as possible.'}
            </span>
          </p>
          <a
            href="mailto:info@nanogenindustrial.com"
            data-testid="contact-email-link"
            className="inline-block text-sm sm:text-xl md:text-2xl font-bold text-white bg-white/10 hover:bg-white/20 transition-colors rounded-xl px-3 py-3 md:px-6 md:py-4 whitespace-nowrap"
          >
            info@nanogenindustrial.com
          </a>
          <div className="mt-8">
            <a
              href="mailto:info@nanogenindustrial.com?subject=Teklif%20Talebi"
              data-testid="contact-send-email-btn"
              className="inline-flex items-center gap-2 bg-white text-blue-800 font-semibold px-8 py-4 rounded-xl hover:bg-blue-50 transition-colors text-lg"
            >
              <Send className="w-5 h-5" />
              {language === 'tr' ? 'E-posta Gönder' : 'Send Email'}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
